export default function Support() {
  return (
    <section id="support" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block px-4 py-2 border border-gray-300 rounded-full text-xs font-semibold text-gray-600 uppercase tracking-wider">
            NEED HELP?
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left Column */}
          <div>
            <h2 className="text-6xl font-extrabold text-gray-900 mb-3 leading-tight">
              We're Here
            </h2>
            <h2 className="text-6xl font-normal text-blue-600 mb-12 leading-tight flex items-center gap-3">
              to Support You
              <span className="text-4xl">🎧</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-10">
              <p>
                Our dedicated support team is available to help you with any questions or technical issues. Whether you need setup assistance or have questions about features, we're just a message away.
              </p>
              <p>
                Get quick answers to common questions or reach out directly for personalized support. Your satisfaction and security are our top priorities.
              </p>
            </div>

            <a
              href="#contact"
              className="inline-block text-blue-600 font-semibold underline hover:text-blue-700 transition-colors"
            >
              Browse FAQ articles →
            </a>
          </div>

          {/* Right Column */}
          <div className="space-y-10">
            <div>
              <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Email Support
              </div>
              <a
                href="mailto:information@stylinedoopozarevac.com"
                className="text-lg text-gray-900 hover:text-blue-600 transition-colors break-all"
              >
                information@stylinedoopozarevac.com
              </a>
            </div>

            <div>
              <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Phone Support
              </div>
              <a
                href="tel:+14705168737"
                className="text-lg text-gray-900 hover:text-blue-600 transition-colors"
              >
                +1 470 516 8737
              </a>
            </div>

            <div>
              <div className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                Support Hours
              </div>
              <div className="text-lg text-gray-900 font-semibold">
                24/7 Available
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
